// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.active-modal {
    overflow-y: hidden;
}

.btn-modal {
    padding: 10px 20px;
    display: block;
    margin: 100px auto 0;
    font-size: 18px;
}

.modal, .overlay {
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    overflow: scroll;
}

.overlay {
    background: rgba(49,49,49,0.8);
}
.modal-content {
    position: absolute;
    top: 15%;
    left: 50%;
    margin: 10px;
    line-height: 1;
    background: #8c8c8c;
    padding: 4px 4px;
    border-radius: 1px;
    max-width: 800px;
    min-width: 300px;
    image-resolution: from-image;
    margin-left:-400px;
}




.button-50 {
position: absolute;
top: 10px;
right: 10px;
padding: 5px 7px;

  appearance: button;
  background-color: #000;
  background-image: none;
  border: 1px solid #000;
  border-radius: 4px;
  box-shadow: #fff 4px 4px 0 0,#000 4px 4px 0 1px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-family: ITCAvantGardeStd-Bk,Arial,sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 10px;
  margin: 0 5px 10px 0;
  overflow: visible;
width: 20px;
  text-align: center;
  text-transform: none;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: middle;
  white-space: nowrap;
}

.button-50:focus {
  text-decoration: none;
}

.button-50:hover {
  text-decoration: none;
}

.button-50:active {
  box-shadow: rgba(0, 0, 0, .125) 0 3px 5px inset;
  outline: 0;
}

.button-50:not([disabled]):active {
  box-shadow: #fff 2px 2px 0 0, #000 2px 2px 0 1px;
  transform: translate(2px, 2px);
}

@media (min-width: 768px) {
  .button-50 {
    padding: 12px 50px;
  }
}



`, "",{"version":3,"sources":["webpack://./src/components/login/login.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;AACtB;;;;;AAKA;AACA,kBAAkB;AAClB,SAAS;AACT,WAAW;AACX,gBAAgB;;EAEd,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,+CAA+C;EAC/C,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iDAAiD;EACjD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;AACnB,WAAW;EACT,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["body.active-modal {\n    overflow-y: hidden;\n}\n\n.btn-modal {\n    padding: 10px 20px;\n    display: block;\n    margin: 100px auto 0;\n    font-size: 18px;\n}\n\n.modal, .overlay {\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    overflow: scroll;\n}\n\n.overlay {\n    background: rgba(49,49,49,0.8);\n}\n.modal-content {\n    position: absolute;\n    top: 15%;\n    left: 50%;\n    margin: 10px;\n    line-height: 1;\n    background: #8c8c8c;\n    padding: 4px 4px;\n    border-radius: 1px;\n    max-width: 800px;\n    min-width: 300px;\n    image-resolution: from-image;\n    margin-left:-400px;\n}\n\n\n\n\n.button-50 {\nposition: absolute;\ntop: 10px;\nright: 10px;\npadding: 5px 7px;\n\n  appearance: button;\n  background-color: #000;\n  background-image: none;\n  border: 1px solid #000;\n  border-radius: 4px;\n  box-shadow: #fff 4px 4px 0 0,#000 4px 4px 0 1px;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-family: ITCAvantGardeStd-Bk,Arial,sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 10px;\n  margin: 0 5px 10px 0;\n  overflow: visible;\nwidth: 20px;\n  text-align: center;\n  text-transform: none;\n  touch-action: manipulation;\n  user-select: none;\n  -webkit-user-select: none;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.button-50:focus {\n  text-decoration: none;\n}\n\n.button-50:hover {\n  text-decoration: none;\n}\n\n.button-50:active {\n  box-shadow: rgba(0, 0, 0, .125) 0 3px 5px inset;\n  outline: 0;\n}\n\n.button-50:not([disabled]):active {\n  box-shadow: #fff 2px 2px 0 0, #000 2px 2px 0 1px;\n  transform: translate(2px, 2px);\n}\n\n@media (min-width: 768px) {\n  .button-50 {\n    padding: 12px 50px;\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
